import {CalendarOutlined} from '@ant-design/icons';
import React from 'react';
import styles from './headerComponent.module.less';
import {User} from "@auth0/auth0-spa-js";
import {useNavigate} from "react-router-dom";
import {RoutingPaths} from "../../pages/routing/routingContainer";
import Logo from "../../assets/logo-warto.svg";
import {CrudHeader} from "digimuth-components/dist";
import classNames from "classnames";
import {getMobileNavigationItems} from "../../navigation/navigationConfig";
import useCurrentUserRoles from '../../hooks/useCurrentUserRoles';
import {OfflineBanner} from "../offlineBanner/offlineBanner";
import {READ_OPERATIONS_ROLES} from "../../helpers/applicationUserHelper";

interface HeaderComponentProps {
    onLogoutPressed: () => Promise<any>,
    onLoginPressed: () => Promise<any>,
    userData?: User | null;
}

export default function HeaderComponent(props: HeaderComponentProps) {
    const navigate = useNavigate();
    const roles = useCurrentUserRoles();
    const mobileMenuItems = getMobileNavigationItems(roles ?? undefined);

    const onCalendarClicked = () => {
        navigate(RoutingPaths.warehouseOperationsCalendar.route);
    }

    return <div className={styles.headerWrapper}>
        <OfflineBanner/>
        <CrudHeader
        logOutButtonClassName={classNames(styles.headerWrapper, styles.logoutButton)}
        routingPaths={RoutingPaths}
        userName={props.userData?.name}
        headerChildren={READ_OPERATIONS_ROLES.some(role => roles?.includes(role)) ? <CalendarOutlined onClick={onCalendarClicked} className={styles.calendarIcon}/> : undefined}
        mobileLogo={<img src={Logo} alt={"logo"} className={styles.mobileLogoImage}/>}
        logo={<img src={Logo} alt={"logo"} className={styles.logoImage}/>}
        upperMenuItems={mobileMenuItems.upper}
        mainMenuItems={mobileMenuItems.main}
        mobileMenuStyles={{header: {backgroundColor: "#0f2747"}}}
        lowerMenuItems={mobileMenuItems.lower}
        onLogout={props.onLogoutPressed}
        mainColor={"#15539e"}
    />
    </div>
}
